module.exports = __webpack_public_path__ + "static/img/2-2.be1fb19d.jpeg";